import React, { useCallback, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "./apiClient";

const useSetGuardDocsPendentes = () => {
  const linkRef = useRef();
  const { request, data, errors, isLoading } = useApiClient();

  const callExternalHandler = useCallback(
    (safePayload) => {
      try {
        if (typeof safePayload === "string") {
          linkRef.current.href = `setrnguard://${safePayload}`;
          linkRef.current.click();
        } else if (Array.isArray(safePayload) && safePayload.length) {
          request(apiRoutes.usuarios.arquivo.selecionar, safePayload);
        }
      } catch (e) {
        toast.warn("Verifique se você instalou o programa SET/RN Guard corretamente. ");
      }
    },
    [request, linkRef],
  );

  useEffect(() => {
    if (data) {
      callExternalHandler(data.result);
    }
  }, [data, errors, callExternalHandler]);

  // A chamada de external handlers exige que parta de um elemento no DOM
  const arquivoLinkRef = (
    <a ref={linkRef} style={{ display: "none" }} href="setrnguard://-">
      .
    </a>
  );

  return {
    linkRef: arquivoLinkRef,
    isLoading,
    assinar: (safePayload) => {
      callExternalHandler(safePayload);
    },
  };
};

export default useSetGuardDocsPendentes;
